// extracted by mini-css-extract-plugin
export default {"modalFooterButtons":"EditModal_modalFooterButtons__dYaNt"};